import { SET_CAP_IS_VISIBLE } from './constants';

export const setCAPIsVisible = isVisible => ({
    type: SET_CAP_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/CAP/actions.js